/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetChoicesOfQuestionQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type GetChoicesOfQuestionQuery = { getQuestion: { choices: Array<{ id: number, name: string }> } };


export const GetChoicesOfQuestionDocument = gql`
    query GetChoicesOfQuestion($id: Int!) {
  getQuestion(id: $id) {
    choices {
      id
      name
    }
  }
}
    `;

/**
 * __useGetChoicesOfQuestionQuery__
 *
 * To run a query within a React component, call `useGetChoicesOfQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChoicesOfQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChoicesOfQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChoicesOfQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetChoicesOfQuestionQuery, GetChoicesOfQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChoicesOfQuestionQuery, GetChoicesOfQuestionQueryVariables>(GetChoicesOfQuestionDocument, options);
      }
export function useGetChoicesOfQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChoicesOfQuestionQuery, GetChoicesOfQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChoicesOfQuestionQuery, GetChoicesOfQuestionQueryVariables>(GetChoicesOfQuestionDocument, options);
        }
export type GetChoicesOfQuestionQueryHookResult = ReturnType<typeof useGetChoicesOfQuestionQuery>;
export type GetChoicesOfQuestionLazyQueryHookResult = ReturnType<typeof useGetChoicesOfQuestionLazyQuery>;
export type GetChoicesOfQuestionQueryResult = Apollo.QueryResult<GetChoicesOfQuestionQuery, GetChoicesOfQuestionQueryVariables>;